<!-- App resource selection begins -->
<div class="margin-bottom double-margin-top collapsible flex-row-start items-center gap-8">
  <h3 class="whitespace-nowrap" (click)="onToggleIncludeConditions()">
    <i class="fa-utility fa-semibold" [ngClass]="includeRulesOpen ? 'fa-angle-down' : 'fa-angle-right'"></i>
    Selection Rules
  </h3>
  @if (inclusionRulesCount$ | async; as inclusionCount) {
    <span class="rule-count-display">
      ({{ inclusionCount.total }} rule{{ inclusionCount.total === 1 ? '' : 's' }} applied)
    </span>
  } @else {
    <span class="rule-count-display">(0 rules)</span>
  }
</div>
<div id="include-rules-container" [class.hidden]="!includeRulesOpen" class="hide-scrollbar">
  <div class="margin-bottom">
    Resources that match <em>any</em> of these rules will be <span class="font-medium">included.</span>
  </div>
  <app-resource-rule-selector
    #inclusionTagSelector
    [action]="'include'"
    [formControl]="formGroup.get('matchingRules')"
    [possibleTags]="possibleTagValues"
    [possibleResourceTypes]="possibleResourceTypes"
    [possibleResourceGroups]="possibleResourceGroups"
    [applicationType]="applicationType"
    [readonly]="readonly"
  ></app-resource-rule-selector>
</div>
<!-- <div class="exclusion-rules-section">
<div class="exclude-rules-section-body" [class.obscured]="shouldObscureExclusionRules">
  <div class="margin-bottom double-margin-top collapsible flex-row-start items-center gap-8">
    <h3 class="whitespace-nowrap" (click)="onToggleExcludeConditions()">
      <i class="fa" [ngClass]="excludeRulesOpen ? 'fa-caret-down' : 'fa-caret-right'"></i>
      Exclusion Rules
    </h3>
    <span class="rule-count-display" *ngIf="(exclusionRulesCount$ | async) as exclusionCount; else exclusionRuleCountDisplay">
      ({{ exclusionCount.total }} rule{{ exclusionCount.total === 1 ? '' : 's' }} applied)
    </span>
    <ng-template #exclusionRuleCountDisplay>
      <span class="rule-count-display">(0 rules)</span>
    </ng-template>
    <div class="toggle-exclusion-rules-container" [class.hidden]="shouldObscureExclusionRules" [class.should-obscure]="shouldObscureExclusionRules"><a (click)="onToggleExclusionRules()">Disallow Editing Exclusion Rules</a></div>
  </div>
  <div id="exclude-rules-container" [class.hidden]="!excludeRulesOpen" class="hide-scrollbar">
    <div class="margin-bottom">Resources that match <em>any</em> of these rules will be <span class="font-medium">excluded</span>, <em>even</em> if they also meet inclusion rules.</div>
    <app-resource-rule-selector #exclusionTagSelector [action]="'exclude'" [formControl]="formGroup.get('excludingRules')" [possibleTags]="possibleTagValues" [readonly]="readonly"></app-resource-rule-selector>
  </div>
</div>
<div class="exclusion-rules-overlay" [class.hidden]="!shouldObscureExclusionRules">
  <div class="toggle-exclusion-rules-container" [class.should-obscure]="shouldObscureExclusionRules">Exclusion rules should be used cautiously. <a (click)="onToggleExclusionRules()">Allow Editing</a></div>
</div>
</div> -->
<div class="flex-row items-center">
  <h3>Available Resources</h3>
  <span class="align-right flex-center-row">
    <filter-form (filter)="onFilterChange($event)"></filter-form>
    <div class="spacer"></div>
    @if (showRescanButton && !readonly) {
      <button
        type="button"
        busy-button
        [disabled]="refreshing"
        [busy]="refreshing"
        class="arpio-secondary-button"
        (click)="onRefreshClick()"
      >
        RESCAN
      </button>
    }
  </span>
</div>
<app-resources-selector
  [formControl]="formGroup.get('resourceSelections')"
  [sourceResources]="resources"
  [refreshing]="refreshing"
  [filterString]="filterText"
  [rpo]="rpo"
  [readonly]="readonly"
  (viewIssues)="viewIssues.emit()"
>
</app-resources-selector>
